import ReferenceList from '@/components/Reference/ReferenceList'
import ReferenceForm from '@/components/Reference/ReferenceForm'
import ReferenceDetail from '@/components/Reference/ReferenceDetail'

let ReferenceRouter = [{
  path: '/reference',
  name: 'ReferenceList',
  component: ReferenceList,
  meta: {
    title: 'Références uniques',
    requiresAuth: true,
    authorizations: ['reference_index', 'desktop_access']
  }
}, {
  path: '/reference/new',
  name: 'ReferenceNew',
  component: ReferenceForm,
  meta: {
    title: 'Nouvelle référence',
    requiresAuth: true,
    authorizations: ['reference_new', 'desktop_access']
  }
}, {
  path: '/reference/:id/edit',
  name: 'ReferenceEdit',
  component: ReferenceForm,
  meta: {
    title: 'Modifier une référence',
    requiresAuth: true,
    authorizations: ['reference_edit', 'desktop_access']
  }
}, {
  path: '/reference/:id',
  name: 'ReferenceDetail',
  component: ReferenceDetail,
  meta: {
    title: 'Fiche référence',
    requiresAuth: true,
    authorizations: ['reference_show', 'desktop_access']
  }
}]

export default ReferenceRouter



// WEBPACK FOOTER //
// ./src/components/Reference/router.js